<div class="pch-wrap" [class.pch-conversation-open]="selectedStaff || switchingConversation">

  <!-- ============ Left pane: conversation list ============ -->
  <div class="pch-list-pane">
    <div class="pch-list-head">
      <h2 class="pch-list-title">{{ 'chat' | translate }}</h2>
    </div>

    <div class="pch-search-row">
      <i class="ri-search-line"></i>
      <input type="text" class="pch-search-input" [(ngModel)]="searchQuery"
             placeholder="{{ 'searchByNameOrMessage' | translate }}" />
    </div>

    <div class="pch-filter-tabs">
      <button type="button" class="pch-filter-tab" [class.active]="activeFilter === 'ALL'" (click)="setFilter('ALL')">{{ 'all' | translate }}</button>
      <button type="button" class="pch-filter-tab" [class.active]="activeFilter === 'UNREAD'" (click)="setFilter('UNREAD')">{{ 'unread' | translate }}</button>
      <button type="button" class="pch-filter-tab" [class.active]="activeFilter === 'TEACHERS'" (click)="setFilter('TEACHERS')">{{ 'teachers' | translate }}</button>
      <button type="button" class="pch-filter-tab" [class.active]="activeFilter === 'SCHOOL_OFFICE'" (click)="setFilter('SCHOOL_OFFICE')">{{ 'schoolOffice' | translate }}</button>
    </div>

    <div class="pch-list" *ngIf="!loading && filteredStaffList.length">
      <div class="pch-thread-row" *ngFor="let s of filteredStaffList" [class.active]="selectedStaff?.staffId === s.staffId" (click)="openConversation(s)">
        <div class="pch-avatar">
          <img *ngIf="s.staffImage" [src]="s.staffImage" alt="{{ s.staffName }}" />
          <span *ngIf="!s.staffImage">{{ s.staffName?.charAt(0) }}</span>
        </div>
        <div class="pch-thread-text">
          <div class="pch-thread-title">{{ s.staffName }}</div>
          <div class="pch-thread-designation">{{ s.designation }}</div>
          <div class="pch-thread-preview">
            <i class="ri-check-double-line pch-status-icon read" *ngIf="!s.isTyping && showsStatusIcon(s) && s.IsRead === 1"></i>
            <i class="ri-check-line pch-status-icon sent" *ngIf="!s.isTyping && showsStatusIcon(s) && s.IsRead !== 1"></i>
            <span class="pch-typing-text" *ngIf="s.isTyping">{{ 'typingEllipsis' | translate }}</span>
            <span *ngIf="!s.isTyping">{{ s.message || ('noMessagesYet' | translate) }}</span>
          </div>
        </div>
        <div class="pch-thread-meta">
          <span class="pch-time" *ngIf="s.timeStamp">{{ formatTime(s.timeStamp) }}</span>
          <span class="pch-unread-badge" *ngIf="s.unreadCount > 0">{{ unreadDisplay(s.unreadCount) }}</span>
        </div>
      </div>
    </div>

    <div class="pch-empty" *ngIf="!loading && !filteredStaffList.length">
      <div class="pe-icon"><i class="ph ph-folder-open"></i></div>
      <div class="pe-title">{{ 'dataNotFound' | translate }}</div>
    </div>

    <div class="pch-list" *ngIf="loading">
      <div class="pch-thread-row" *ngFor="let i of [1,2,3,4,5,6]">
        <div class="pch-skeleton pch-skeleton-avatar"></div>
        <div class="pch-thread-text">
          <div class="pch-skeleton pch-skeleton-line pch-skeleton-line-title"></div>
          <div class="pch-skeleton pch-skeleton-line pch-skeleton-line-sub"></div>
        </div>
      </div>
    </div>
  </div>

  <!-- ============ Right pane: conversation thread ============ -->
  <div class="pch-card">
    <ng-container *ngIf="selectedStaff; else pchNoConversation">
      <div class="pch-thread-head">
        <button type="button" class="pch-back-btn" (click)="closeConversation()"><i class="ri-arrow-left-line"></i></button>
        <div class="pch-avatar">
          <img *ngIf="selectedStaff.staffImage" [src]="selectedStaff.staffImage" alt="{{ selectedStaff.staffName }}" />
          <span *ngIf="!selectedStaff.staffImage">{{ selectedStaff.staffName?.charAt(0) }}</span>
        </div>
        <div class="pch-thread-text">
          <div class="pch-thread-title">
            {{ selectedStaff.staffName }}
            <span class="pch-presence-dot" [class.online]="userOnline"></span>
          </div>
          <div class="pch-thread-subtitle">
            <span>{{ selectedStaff.designation }}</span>
            <span *ngIf="!isTyping"> &middot; {{ (userOnline ? 'online' : 'offline') | translate }}</span>
            <span class="pch-typing-text" *ngIf="isTyping"> &middot; {{ 'typingEllipsis' | translate }}</span>
          </div>
        </div>
      </div>

      <div class="pch-messages" id="pch-chat-scroll" (scroll)="onMessagesScroll($event)">
        <div class="pch-load-more" *ngIf="paginationLoading">
          <i class="ri-loader-4-line pch-spin"></i>
        </div>

        <div class="pch-empty" *ngIf="conversationLoading">
          <i class="ri-loader-4-line pch-spin"></i>
          {{ 'loadingMessages' | translate }}
        </div>

        <ng-container *ngIf="!conversationLoading">
          <ng-container *ngFor="let bucket of chatBuckets; trackBy: trackByBucketDate">
            <div class="pch-date-divider"><span>{{ dayLabelFor(bucket.date) }}</span></div>
            <div class="pch-bubble-row" *ngFor="let m of bucket.messages; trackBy: trackByMessageUid" [class.self]="isOwnMessage(m.fromUserId)">
              <div class="pch-bubble" [class.self]="isOwnMessage(m.fromUserId)">
                <div class="pch-bubble-text">{{ m.message }}</div>
                <div class="pch-bubble-time">
                  {{ formatTime(m.timeStamp) }}
                  <i class="ri-time-line pch-status-icon pending" *ngIf="messageStatus(m) === 'pending'"></i>
                  <i class="ri-check-line pch-status-icon sent" *ngIf="messageStatus(m) === 'sent'"></i>
                  <i class="ri-check-double-line pch-status-icon read" *ngIf="messageStatus(m) === 'read'"></i>
                </div>
              </div>
            </div>
          </ng-container>

          <div class="pch-empty" *ngIf="!chatBuckets.length && !isTyping">
            <i class="ri-chat-3-line"></i>
            {{ 'noMessagesYetSayHello' | translate }}
          </div>

          <div class="pch-bubble-row" *ngIf="isTyping">
            <ng-lottie [options]="typingAnimationOptions" class="pch-typing-animation"></ng-lottie>
          </div>
        </ng-container>
      </div>

      <div class="pch-exceeded" *ngIf="chatExceeded">
        <i class="ri-error-warning-line"></i> {{ chatExceededMessage }}
      </div>

      <div class="pch-input-row" *ngIf="!chatExceeded">
        <input type="text" class="pch-input" placeholder="{{ 'writeAMessageTo' | translate }} {{ selectedStaff.staffName }}"
               [(ngModel)]="chatMessage" (input)="onTyping()" (keyup.enter)="sendMessage()" />
        <button type="button" class="pch-send-btn" [disabled]="!chatMessage || !chatMessage.trim()" (click)="sendMessage()">
          <i class="ri-send-plane-line"></i>
        </button>
      </div>
    </ng-container>

    <ng-template #pchNoConversation>
      <div class="pch-no-conversation" *ngIf="!switchingConversation">
        <i class="ri-chat-3-line"></i>
        <p>{{ 'selectAConversationToStart' | translate }}</p>
      </div>
      <div class="pch-no-conversation" *ngIf="switchingConversation">
        <i class="ri-loader-4-line pch-spin"></i>
        <p>{{ 'loadingEllipsis' | translate }}</p>
      </div>
    </ng-template>
  </div>
</div>
